import { SupportEmailLink } from "src/global/ui/SupportEmailLink/SupportEmailLink.tsx"

export const REFRESH_AND_TRY_AGAIN_OR_CONTACT_SUPPORT = (
  <>
    Refresh the page and try again. If the problem persists, contact <SupportEmailLink />.
  </>
)
